import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COUNTRIES = [
  { code: 'IT', it: 'Italia', en: 'Italy', fr: 'Italie', de: 'Italien', es: 'Italia', nl: 'Italië', pl: 'Włochy', pt: 'Itália' },
  { code: 'FR', it: 'Francia', en: 'France', fr: 'France', de: 'Frankreich', es: 'Francia', nl: 'Frankrijk', pl: 'Francja', pt: 'França' },
  { code: 'DE', it: 'Germania', en: 'Germany', fr: 'Allemagne', de: 'Deutschland', es: 'Alemania', nl: 'Duitsland', pl: 'Niemcy', pt: 'Alemanha' },
  { code: 'ES', it: 'Spagna', en: 'Spain', fr: 'Espagne', de: 'Spanien', es: 'España', nl: 'Spanje', pl: 'Hiszpania', pt: 'Espanha' },
  { code: 'CH', it: 'Svizzera', en: 'Switzerland', fr: 'Suisse', de: 'Schweiz', es: 'Suiza', nl: 'Zwitserland', pl: 'Szwajcaria', pt: 'Suíça' },
  { code: 'AT', it: 'Austria', en: 'Austria', fr: 'Autriche', de: 'Österreich', es: 'Austria', nl: 'Oostenrijk', pl: 'Austria', pt: 'Áustria' },
  { code: 'NL', it: 'Paesi Bassi', en: 'Netherlands', fr: 'Pays-Bas', de: 'Niederlande', es: 'Países Bajos', nl: 'Nederland', pl: 'Holandia', pt: 'Países Baixos' },
  { code: 'BE', it: 'Belgio', en: 'Belgium', fr: 'Belgique', de: 'Belgien', es: 'Bélgica', nl: 'België', pl: 'Belgia', pt: 'Bélgica' },
  { code: 'GB', it: 'Regno Unito', en: 'United Kingdom', fr: 'Royaume-Uni', de: 'Vereinigtes Königreich', es: 'Reino Unido', nl: 'Verenigd Koninkrijk', pl: 'Wielka Brytania', pt: 'Reino Unido' },
  { code: 'US', it: 'Stati Uniti', en: 'United States', fr: 'États-Unis', de: 'USA', es: 'Estados Unidos', nl: 'Verenigde Staten', pl: 'Stany Zjednoczone', pt: 'Estados Unidos' },
  { code: 'PT', it: 'Portogallo', en: 'Portugal', fr: 'Portugal', de: 'Portugal', es: 'Portugal', nl: 'Portugal', pl: 'Portugalia', pt: 'Portugal' },
  { code: 'PL', it: 'Polonia', en: 'Poland', fr: 'Pologne', de: 'Polen', es: 'Polonia', nl: 'Polen', pl: 'Polska', pt: 'Polónia' },
  { code: 'OTHER', it: 'Altro', en: 'Other', fr: 'Autre', de: 'Andere', es: 'Otro', nl: 'Anders', pl: 'Inne', pt: 'Outro' },
];

const i18n = {
  title: { it: 'Richiedi contatto', en: 'Request contact', fr: 'Demander à être contacté', de: 'Kontakt anfordern', es: 'Solicitar contacto', nl: 'Contact aanvragen', pl: 'Poproś o kontakt', pt: 'Pedir contacto' },
  subtitle: { it: 'Inserisci i dati dell\'immobile.', en: 'Enter property details.', fr: 'Entrez les détails du bien.', de: 'Bitte gib die Immobiliendaten ein.', es: 'Introduce los datos del inmueble.', nl: 'Vul de gegevens van het pand in.', pl: 'Wprowadź dane nieruchomości.', pt: 'Insere os dados do imóvel.' },
  yourContact: { it: 'I tuoi contatti', en: 'Your contacts', fr: 'Vos contacts', de: 'Deine Kontakte', es: 'Tus contactos', nl: 'Jouw contactgegevens', pl: 'Twoje dane kontaktowe', pt: 'Os teus contactos' },
  propertyData: { it: 'Dati immobile', en: 'Property data', fr: 'Données du bien', de: 'Immobiliendaten', es: 'Datos del inmueble', nl: 'Gegevens van het pand', pl: 'Dane nieruchomości', pt: 'Dados do imóvel' },
  state: { it: 'Stato', en: 'Country', fr: 'Pays', de: 'Land', es: 'País', nl: 'Land', pl: 'Kraj', pt: 'País' },
  comune: { it: 'Comune', en: 'City / Municipality', fr: 'Commune', de: 'Gemeinde', es: 'Municipio', nl: 'Gemeente', pl: 'Gmina', pt: 'Município' },
  address: { it: 'Indirizzo', en: 'Address', fr: 'Adresse', de: 'Adresse', es: 'Dirección', nl: 'Adres', pl: 'Adres', pt: 'Morada' },
  disclaimer: { it: 'Ti metteremo in contatto con un nostro partner per un approfondimento senza impegno.', en: 'We will put you in contact with one of our partners for a no-obligation discussion.', fr: 'Nous vous mettrons en relation avec un partenaire pour un échange sans engagement.', de: 'Wir vermitteln dich an einen unserer Partner für ein unverbindliches Gespräch.', es: 'Te pondremos en contacto con uno de nuestros socios para una conversación sin compromiso.', nl: 'Wij brengen je in contact met een van onze partners voor een vrijblijvend gesprek.', pl: 'Skontaktujemy Cię z naszym partnerem w celu niezobowiązującej rozmowy.', pt: 'Vamos pôr-te em contacto com um dos nossos parceiros para uma conversa sem compromisso.' },
  submit: { it: 'Invia richiesta', en: 'Submit request', fr: 'Envoyer la demande', de: 'Anfrage senden', es: 'Enviar solicitud', nl: 'Aanvraag versturen', pl: 'Wyślij zgłoszenie', pt: 'Enviar pedido' },
  cancel: { it: 'Annulla', en: 'Cancel', fr: 'Annuler', de: 'Abbrechen', es: 'Cancelar', nl: 'Annuleren', pl: 'Anuluj', pt: 'Cancelar' },
  required: { it: 'Tutti i campi sono obbligatori', en: 'All fields are required', fr: 'Tous les champs sont obligatoires', de: 'Alle Felder sind erforderlich', es: 'Todos los campos son obligatorios', nl: 'Alle velden zijn verplicht', pl: 'Wszystkie pola są wymagane', pt: 'Todos os campos são obrigatórios' },
  selectCountry: { it: 'Seleziona uno Stato', en: 'Select a country', fr: 'Choisissez un pays', de: 'Land auswählen', es: 'Selecciona un país', nl: 'Selecteer een land', pl: 'Wybierz kraj', pt: 'Seleciona um país' },
};
const T = (k, lang) => (i18n[k] && i18n[k][lang]) || i18n[k]?.it || k;

export default function PropertyLeadForm({ token, language, onClose, onSuccess, inline = false }) {
  const L = (language || 'it').toLowerCase();
  const [prefill, setPrefill] = useState(null);
  const [propertyState, setPropertyState] = useState('IT');
  const [propertyComune, setPropertyComune] = useState('');
  const [propertyAddress, setPropertyAddress] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/public/guest-video/${token}/prefill`);
        setPrefill(r.data);
        if (r.data.country) setPropertyState(r.data.country);
      } catch (_) {
        setPrefill({ first_name: '', last_name: '', email: '', phone: '' });
      }
    })();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!propertyState || !propertyComune.trim() || !propertyAddress.trim()) {
      setError(T('required', L));
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/public/guest-video/${token}/property-lead`, {
        property_state: propertyState,
        property_comune: propertyComune.trim(),
        property_address: propertyAddress.trim(),
      });
      onSuccess && onSuccess();
    } catch (e) {
      setError(e.response?.data?.detail || 'Errore invio');
    } finally {
      setSubmitting(false);
    }
  };

  const content = (
      <div className={inline ? 'bg-white w-full rounded-3xl overflow-hidden shadow-xl shadow-rose-100/60 border border-rose-100' : 'bg-white w-full max-w-md max-h-[95vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl shadow-2xl'}>
        <div className="sticky top-0 bg-gradient-to-r from-rose-600 to-pink-600 text-white px-5 py-4 sm:rounded-t-3xl flex items-center justify-between">
          <div>
            <h2 className="text-lg font-bold">{T('title', L)}</h2>
            <p className="text-xs text-rose-100 mt-0.5">{T('subtitle', L)}</p>
          </div>
          {!inline && (
            <button onClick={onClose} className="text-white/80 hover:text-white text-2xl leading-none p-1" data-testid="property-lead-close" aria-label="Close">×</button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="p-5 space-y-5">
          {/* Recapiti pre-compilati */}
          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-2">{T('yourContact', L)}</h3>
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 space-y-1.5 text-sm">
              <div><span className="text-slate-500">👤</span> <strong>{prefill?.first_name || '...'} {prefill?.last_name || ''}</strong></div>
              <div><span className="text-slate-500">✉️</span> {prefill?.email || '...'}</div>
              <div><span className="text-slate-500">📱</span> {prefill?.phone || '...'}</div>
            </div>
          </div>

          {/* Dati immobile */}
          <div>
            <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-2">{T('propertyData', L)}</h3>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('state', L)} *</label>
                <select
                  value={propertyState}
                  onChange={(e) => setPropertyState(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500"
                  data-testid="property-lead-state"
                  required
                >
                  <option value="">{T('selectCountry', L)}</option>
                  {COUNTRIES.map(c => (
                    <option key={c.code} value={c.code}>{c[L] || c.it}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('comune', L)} *</label>
                <input
                  type="text"
                  value={propertyComune}
                  onChange={(e) => setPropertyComune(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500"
                  placeholder={L === 'it' ? 'es. Cogoleto' : 'e.g. Genoa'}
                  data-testid="property-lead-comune"
                  required
                />
              </div>
              <div>
                <label className="text-xs text-slate-600 font-medium mb-1 block">{T('address', L)} *</label>
                <input
                  type="text"
                  value={propertyAddress}
                  onChange={(e) => setPropertyAddress(e.target.value)}
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500"
                  placeholder={L === 'it' ? 'es. Via Roma 12' : 'e.g. Main St 12'}
                  data-testid="property-lead-address"
                  required
                />
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="bg-amber-50 border-l-4 border-amber-400 p-3 text-xs text-amber-900 rounded-r-lg">
            ℹ️ {T('disclaimer', L)}
          </div>

          {error && (
            <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm p-3 rounded-lg" data-testid="property-lead-error">{error}</div>
          )}

          <div className="flex gap-2 pt-2">
            {!inline && (
              <button
                type="button"
                onClick={onClose}
                className="flex-1 py-3 border-2 border-slate-300 text-slate-700 rounded-xl font-semibold text-sm hover:bg-slate-50"
                data-testid="property-lead-cancel"
              >{T('cancel', L)}</button>
            )}
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 py-3 bg-gradient-to-r from-rose-600 to-pink-600 text-white rounded-xl font-semibold text-sm shadow-lg disabled:opacity-50"
              data-testid="property-lead-submit"
            >{submitting ? '...' : T('submit', L)}</button>
          </div>
        </form>
      </div>
  );
  if (inline) return content;
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/70 flex items-end sm:items-center justify-center p-0 sm:p-4 animate-in fade-in" data-testid="property-lead-modal">
      {content}
    </div>
  );
}
